import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";

function JoinTheTeamForm() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };

  const nextRef = useRef(null);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    nmls_LicenseNumber: "",
    smsToPhone: "No", // default No
    _id: "",
    subject: "Join Our Family",
  });

  const [isLoading, setIsLoading] = useState(false);

  function generateId() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const date = String(now.getDate()).padStart(2, "0");
    const day = now.toLocaleString("en-US", { weekday: "short" }).toUpperCase();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    return `${year}${month}${date}${day}${hours}${minutes}${seconds}`;
  }

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      _id: generateId(),
    }));
  }, []);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  function updateSubjectContactUs(event) {
    event.preventDefault();
    setIsLoading(true);

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbwtC1vtf0ig0F3phREuqP4K6C6dm-UMlzgqbsHYNs3UWxmdmkaeDxRQNU8cP6oPTS5Fgg/exec";

    fetch(scriptURL, {
      method: "POST",
      body: data,
    })
      .then((response) => {
        if (response.ok) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Error!", error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    // <div className="purchaseBottomRightBox contactUsBottomRightBox FreeQuoteBox">
    <div className="joinTheTeamParent">
      <div className=" contactUsBottomRightBox FreeQuoteBox joinTheTeamBox">
        <span className="purchaseBottomRightHeading joinTheTeamHeading">
          Bring your passion. We’ll fuel the rest.
        </span>
        <span className="purchaseBottomRightContent">
          Kindly complete the form below.
        </span>
        <form
          className={`purchaseBottomRightform ${isLoading ? "loading" : ""}`}
          onSubmit={updateSubjectContactUs}
        >
          <input
            type="hidden"
            name="_subject"
            id="subject"
            value={formData.subject + formData.firstName + formData.lastName}
          />
          <input type="hidden" name="id" value={formData._id} />
          <input type="hidden" name="_template" value="table" />
          <input
            type="hidden"
            name="_next"
            ref={nextRef}
            value="https://google.com"
          />
          <input type="hidden" name="_captcha" value="false" />

          <input
            type="text"
            placeholder="FIRST NAME:"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            autoComplete="true"
            required
          />
          <input
            type="text"
            placeholder="LAST NAME:"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            autoComplete="true"
            required
          />
          <input
            type="email"
            placeholder="EMAIL:"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            autoComplete="true"
            required
          />
          <input
            type="tel"
            placeholder="PHONE:"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            maxLength="10"
            minLength="10"
            pattern="[0-9]*"
            inputMode="numeric"
            autoComplete="true"
            required
          />

          <input
            type="text"
            placeholder="NMLS License Number:"
            id="nmls_LicenseNumber"
            name="nmls_LicenseNumber"
            value={formData.nmls_LicenseNumber}
            onChange={handleChange}
            autoComplete="true"
            required
          />
          <div className="smsToPhoneNoAndSubmitButton">
            <label className="smsToPhoneNo">
              <input
                type="checkbox"
                name="smsToPhone"
                checked={formData.smsToPhone === "Yes"}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    smsToPhone: e.target.checked ? "Yes" : "No",
                  }))
                }
              />
              By checking this box, I agree to receive recurring automated
              marketing text messages from The Mortgageist Inc. at the number
              provided.
            </label>
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
          <span className="conditionMsg">
            <Link to="/privacy-policy" onClick={scrollToTop}>
              Consent is not a condition of purchase. Msg & data rates may
              apply. I agree to the [Privacy Policy].
            </Link>
          </span>
          {/* <div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div> */}
        </form>
      </div>
    </div>
  );
}

export default JoinTheTeamForm;
